import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";

import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import TwitterIcon from "@material-ui/icons/Twitter";
import YouTubeIcon from "@material-ui/icons/YouTube";

import { useStyles } from "./UserAbout.css";
import UserHeader from "../../../Components/NavBar/User/UserHeader/UserHeader";
import Axios from "axios";
import { url } from "../../../Config/Config";
import { publicImageUrl } from "../../../Config/publicImageUrl";
import NameIcon from "../../../Assets/Logo/NameIcon.svg";
import AddressIcon from "../../../Assets/Logo/AddressIcon.svg";
import EmailIcon from "../../../Assets/Logo/EmailIcon.svg";
import PhoneIcon from "../../../Assets/Logo/PhoneIcon.svg";
import MobileIcon from "../../../Assets/Logo/MobileIcon.svg";

class UserAbout extends Component {
  constructor(props) {
    super(props);
    this.state = { schoolDetails: {} };
  }

  componentDidMount() {
    this.getSchoolInfo();
  }

  getSchoolInfo = async () => {
    const response = await Axios.get(`${url}/api/setting`);
    if (response.data) {
      this.setState({ schoolDetails: response.data });
    }
  };

  render() {
    const { classes } = this.props;
    const { schoolDetails } = this.state;
    return (
      <div className={classes.root}>
        <UserHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />
          <div className={classes.bodyContent}>
            {schoolDetails.schoolLogo && (
              <img
                src={`${publicImageUrl}/${schoolDetails.schoolLogo}`}
                alt="Logo"
                style={{ width: 100, height: 100 }}
              />
            )}
            <ListItem
              style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "flex-start",
              }}
            >
              <img
                src={NameIcon}
                alt="name"
                style={{ width: 20, height: 20, marginRight: 10 }}
              />
              <div>{schoolDetails.schoolName}</div>
            </ListItem>
            <ListItem
              style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "flex-start",
              }}
            >
              <img
                src={NameIcon}
                alt="name"
                style={{ width: 20, height: 20, marginRight: 10 }}
              />
              <div>{schoolDetails.shortName}</div>
            </ListItem>
            <ListItem>
              <img
                src={AddressIcon}
                alt="address"
                style={{ width: 20, height: 20, marginRight: 10 }}
              />
              {schoolDetails.address}
            </ListItem>
            <ListItem>
              <img
                src={PhoneIcon}
                alt="phone"
                style={{ width: 20, height: 20, marginRight: 10 }}
              />
              {schoolDetails.landLineNumber}
            </ListItem>
            <ListItem>
              <img
                src={MobileIcon}
                alt="mobile"
                style={{ width: 20, height: 20, marginRight: 10 }}
              />
              {schoolDetails.mobileNumber}
            </ListItem>
            <ListItem>
              <img
                src={EmailIcon}
                alt="email"
                style={{ width: 20, height: 20, marginRight: 10 }}
              />
              {schoolDetails.email}
            </ListItem>
            <Divider />
            {schoolDetails.altLandLineNumber && (
              <ListItem>
                <img
                  src={PhoneIcon}
                  alt="phone"
                  style={{ width: 20, height: 20, marginRight: 10 }}
                />
                {schoolDetails.altLandLineNumber}
              </ListItem>
            )}
            {schoolDetails.altMobileNumber && (
              <ListItem>
                <img
                  src={MobileIcon}
                  alt="mobile"
                  style={{ width: 20, height: 20, marginRight: 10 }}
                />
                {schoolDetails.altMobileNumber}
              </ListItem>
            )}
            {schoolDetails.altEmail && (
              <ListItem>
                <img
                  src={EmailIcon}
                  alt="email"
                  style={{ width: 20, height: 20, marginRight: 10 }}
                />
                {schoolDetails.altEmail}
              </ListItem>
            )}

            <div style={{ padding: 10 }}>
              <a
                href={schoolDetails.fbLink}
                target="_blank"
                rel="noreferrer"
                style={{ marginRight: 10 }}
              >
                <FacebookIcon />
              </a>
              <a
                href={schoolDetails.instaLink}
                target="_blank"
                rel="noreferrer"
                style={{ marginRight: 10 }}
              >
                <InstagramIcon />
              </a>
              <a
                href={schoolDetails.twitterLink}
                target="_blank"
                rel="noreferrer"
                style={{ marginRight: 10 }}
              >
                <TwitterIcon />
              </a>
              <a
                href={schoolDetails.youtubeLink}
                target="_blank"
                rel="noreferrer"
                style={{ marginRight: 10 }}
              >
                <YouTubeIcon />
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(UserAbout);
